import React from 'react';
import { useSignOut } from '../../auth/hooks/useSignOut';
import useAuth from '../../auth/authContext';

export const SwitchUser = () => {
  const { signOut } = useSignOut();
  const {
    state: { user },
  } = useAuth();

  return (
    <div className="growegy-title12">
      <span className="growegy-font--neutral500"> Not {user?.email}?</span>&nbsp;
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a
        href="#"
        onClick={async (e) => {
          e.preventDefault();
          await signOut();
        }}
      >
        Switch user
      </a>
    </div>
  );
};
